import { usePay } from "@/hooks/usePay";
import { usePurchasePass } from "@/hooks/usePurchasePass";
import { fetchAccount } from "@/services/account.queries";
import { isEmail, isPhone } from "@/utils/etc";
import { formatPhoneNumber } from "@/utils/formatPhoneNumber";
import { getValueFromStorage } from "@/utils/secureStore";
import { useQuery } from "@tanstack/react-query";

export const useCheckoutConfirmation = (
  isPurchasingPass: boolean,
  termsAndConditionsOKTimestamp: string,
  rateID: string | null,
  session_id: string | undefined,
  session_token?: string | undefined,
) => {
  const {
    data: contactInfo,
    isPending: isContactInfoPending,
    refetch: refetchContact,
  } = useQuery({
    queryKey: ["checkoutConfirmationContact"],
    queryFn: async () => {
      const contact = await getValueFromStorage("contact");
      if (contact) {
        if (isPhone(contact)) {
          return formatPhoneNumber(contact);
        }
        return isEmail(contact) ? contact : "";
      }

      const idToken = await getValueFromStorage("idToken");
      if (!idToken) return "";

      const rsp = await fetchAccount({ cognitoIDToken: idToken || "" });
      return formatPhoneNumber(rsp.phone);
    },
  });

  const { data: payData, isPending: isPayPending } = usePay(!isPurchasingPass, termsAndConditionsOKTimestamp, session_id, session_token);
  const { data: purchaseData, isPending: isPurchasePending } = usePurchasePass(
    isPurchasingPass,
    termsAndConditionsOKTimestamp,
    session_id,
    rateID,
    session_token,
  );

  const receiptID = payData?.receiptID ?? purchaseData?.receiptID ?? "";

  return {
    receiptID,
    purchasePassData: (isPurchasingPass ? purchaseData : null) ?? null,
    contactInfo,
    refetchContact,
    isPending: isContactInfoPending || isPurchasingPass ? isPurchasePending : isPayPending,
  };
};
